// Indexado pelo CÓDIGO do plano no billing. Código desconhecido — inclusive os planos com
// IA4COM enquanto seus códigos não forem definidos — cai em DEFAULT_STYLES.
const PLAN_STYLES = {
  manager: {
    card: 'bg-gray-50 border-gray-200',
    badge: 'bg-gray-100 text-gray-700 border-2 border-gray-400 font-bold'
  },
  support: {
    card: 'bg-blue-50 border-blue-200',
    badge: 'bg-blue-100 text-blue-700 border-2 border-blue-400 font-bold'
  },
  negotiation: {
    card: 'bg-amber-50 border-amber-200',
    badge: 'bg-amber-100 text-amber-700 border-2 border-amber-400 font-bold'
  },
  unlimited: {
    card: 'bg-purple-50 border-purple-200',
    badge: 'bg-purple-100 text-purple-700 border-2 border-purple-400 font-bold'
  }
}

const DEFAULT_STYLES = {
  card: 'bg-gray-50 border-gray-200',
  badge: 'bg-gray-100 text-gray-700 border-2 border-gray-400 font-bold'
}

export function ensureTailwindCdn () {
  if (document.getElementById('tailwind-cdn')) return
  const script = document.createElement('script')
  script.id = 'tailwind-cdn'
  script.src = 'https://cdn.tailwindcss.com'
  script.onload = () => {
    if (window.tailwind) {
      window.tailwind.config = {
        important: '.pricing-wrapper',
        corePlugins: { preflight: false }
      }
    }
  }
  document.head.appendChild(script)
}

export function getPlanCardClasses (planCode) {
  return (PLAN_STYLES[planCode] && PLAN_STYLES[planCode].card) || DEFAULT_STYLES.card
}

export function getPlanBadgeClasses (planCode) {
  return (PLAN_STYLES[planCode] && PLAN_STYLES[planCode].badge) || DEFAULT_STYLES.badge
}



// WEBPACK FOOTER //
// ./src/utils/subscription-plan-styles.js